import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ButtonInfo } from '../../models/builderIO/types';
import { builder } from "@builder.io/react";

interface BuilderIOState {
    button: ButtonInfo,
    isBuilderPage: boolean | null
}

const initialState: BuilderIOState = {
    button: {
        actionName: null,
        actionDateTime: null
    },
    isBuilderPage: null
};

export const isBuilderPageAsync = createAsyncThunk(
    "builder/isBuilderPage",
    async () => {
        let builderPage = "";

        const visitorSubdirectory = `/${process.env.REACT_APP_SUBDIRECTORY}`;
        const customerSubdirectory = `/${process.env.REACT_APP_STOREFRONT_SUBDIRECTORY}`;

        if (window.location.pathname.startsWith(visitorSubdirectory))
            builderPage = window.location.pathname.slice(visitorSubdirectory.length);
        else if (window.location.pathname.startsWith(customerSubdirectory))
            builderPage = window.location.pathname.slice(customerSubdirectory.length);

        try {
            const content = await builder
                .get("page", { url: builderPage })
                .promise();

            return content !== undefined;
        } catch {
            return false;
        }
    }
);

const builderIOSlice = createSlice({
    name: 'builderIO',
    initialState,
    reducers: {
        buttonClick: (state, action: PayloadAction<string>) => {
            state.button.actionName = action.payload;
            state.button.actionDateTime = (new Date()).toUTCString();
        },
    },
    extraReducers: (builder) => {
        builder.addCase(isBuilderPageAsync.fulfilled, (state, action: PayloadAction<boolean>) => {
            state.isBuilderPage = action.payload;
        });
        builder.addCase(isBuilderPageAsync.pending, (state) => {
            state.isBuilderPage = null;
        });
    },
});

export const { buttonClick } = builderIOSlice.actions;

export default builderIOSlice.reducer;

